export default __webpack_public_path__ + "static/media/Sefcon-500-ban.7421de01.jpg";